import {
  VALIDATION_PASSES_LOADING,
  VALIDATION_PASSES_SUCCESS,
  VALIDATION_PASSES_FAILURE
} from '../constants/ActionTypes';
import { dispatchError, cachedFetchGet } from '../utils/fetch';

export default function getMemberBenefits(passNumbers) {
  const normalizedPassNumbersObject = {};
  passNumbers.map(
    (pass, idx) =>
      (normalizedPassNumbersObject[`pass_no[${idx}]`] = pass.pass_no)
  );

  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const { config } = getState();

      dispatch({
        type: VALIDATION_PASSES_LOADING
      });

      cachedFetchGet(config, 'memberBenefits', {
        client: config.client,
        headNode: config.headNode,
        ...normalizedPassNumbersObject
      })
        .then(validatedPasses => {
          dispatch({
            type: VALIDATION_PASSES_SUCCESS,
            validatedPasses
          });

          resolve();
        })
        .catch((...args) => {
          dispatchError(dispatch, {
            type: VALIDATION_PASSES_FAILURE
          })(...args);
          reject(...args);
        });
    });
}
